import { EventEmitter, Injectable } from '@angular/core';
import { TimelineCanvasLevel } from './timeline-canvas-level';
import { Milliseconds, RequestAnimationFrameId } from '../../../types';
import { Recorder } from '../../entities/recorder';
import { TimelineStore } from '../timeline.store';

let instance: TimelineCanvasProcessLevelsStore;

@Injectable()
export class TimelineCanvasProcessLevelsStore {
  levels: TimelineCanvasLevel[] = [];
  renderLevel: EventEmitter<TimelineCanvasLevel> = new EventEmitter();
  previousTime: Milliseconds;

  private requestAnimationFrameId: RequestAnimationFrameId;
  private shouldTimelineMove = false;

  constructor(private recorder: Recorder, private timelineStore: TimelineStore) {
    if (instance) {
      return instance;
    } else {
      instance = this;
    }

    recorder.onProgress
      .subscribe(levels => this.onRecordingProgress(levels));

    recorder.recordingChange
      .subscribe(recording => this.onRecordingChange(recording));
  }

  private onRecordingChange(recording: boolean) {
    if (recording) {
      this.previousTime = Date.now();
      this.shouldTimelineMove = false;
      this.requestAnimationFrame();
    } else {
      this.stopAnimation();
      this.shouldTimelineMove = false;
    }
  }

  private requestAnimationFrame() {
    this.requestAnimationFrameId = requestAnimationFrame(() => this.animate());
  }

  private stopAnimation() {
    cancelAnimationFrame(this.requestAnimationFrameId);
  }

  private animate() {
    if (this.shouldTimelineMove) {
      this.moveTimeline();
    }

    this.renderLevels();
    this.requestAnimationFrame();
  }

  private moveTimeline() {
    const lastLevel: TimelineCanvasLevel = this.levels[this.levels.length - 1];
    const currentTime = Date.now();

    if (lastLevel) {
      this.timelineStore.currentPosition = lastLevel.endPosition;
    } else {
      this.timelineStore.currentPosition += (currentTime - this.previousTime);
    }

    this.previousTime = currentTime;
  }

  private renderLevels() {
    let level: TimelineCanvasLevel;

    while (level = this.levels.pop()) {
      this.renderLevel.emit(level);
    }
  }

  private onRecordingProgress(levels: TimelineCanvasLevel[]) {
    this.shouldTimelineMove = true;

    if (levels && levels.forEach) {
      levels.forEach(level => this.levels.push(level));
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/rec/timeline/timeline-canvas/timeline-canvas-process-levels.store.ts